/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Status object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Status = {
	/*
	 * Internal
	 */
	services: {},
	running: false,
	init: function () {
		var self = this;
		var refresh = function () {
			var params = {};
			for (var i in self.services) {
				params[self.services[i].name] = typeof self.services[i].beforeCallback == "function" ? self.services[i].beforeCallback() : true;
			}
			
			Api.get('/status', params, function (data) {
				
				for (var i in self.services) {
					self.services[i].afterCallback(data);
				}
				
			});
		};
		if (!self.running && Object.keys(self.services).length > 0) {
			self.running = true;
			self.interval = setInterval(refresh, 10000);
		}
		refresh();
	},
	
	/**
	 * Add a service.
	 *
	 * @param name              Identify the service locally and in the API.
	 * @param beforeCallback    Optional. This callback is called before the global request. If the function returns something will be passed as parameters.
	 * @param afterCallback        This callback is called after the global request with the response parameter.
	 */
	add: function (name, a, b) {
		var beforeCallback = a,
			afterCallback = b;
		
		if (typeof b != 'function') {
			beforeCallback = true;
			afterCallback = a;
		}
		
		this.services[name] = {name: name, beforeCallback: beforeCallback, afterCallback: afterCallback};
		this.init();
	},
	
	/**
	 * Remove a service.
	 *
	 * @param    String name        The name of the service.
	 */
	remove: function (name) {
		delete this.services[name];
		if (Object.keys(this.services).length == 0) {
			this.running = false;
			clearInterval(this.interval);
		}
	}
};